<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
			<v-tabs
				app
				show-arrows
				:height="32"
				class="tabs-route"
				background-color="transparent"
				slider-color="primary">
                <v-tab 
                    exact-path
                    ripple
                    :to="{ path: '/companies/destinations/' + id + '/'}"
                    key="destinations">
                    {{ $trans('destination') }}
                </v-tab>
                <v-tab
                    v-if="$store.getters.checkModelPermissions('saleorder')"
                    exact-path
                    ripple
                    :to="{
                        path: '/companies/destinations/' + id + '/saleorders',
                        query: { company_id: defaultInput.company_id }
                    }"
                    key="saleorders">
                    {{ $trans('saleorders') }}
                </v-tab>
                <v-tab 
                    v-if="$store.getters.checkModelPermissions('trouble')"
                    exact-path
                    ripple
                    :to="{ path: '/companies/destinations/' + id + '/tickets' }"
                    key="tickets">
                    Ticket
                </v-tab>
			</v-tabs>

            <v-slide-y-reverse-transition>
                <router-view v-show="!$store.getters.progress" :key="$route.fullPath" :default-input="defaultInput" :entity-title="entityTitle"></router-view>
            </v-slide-y-reverse-transition>

        </v-col>
    </v-row>
</template>

<script>
    import breadcrumbEntityMixin from '@/mixins/breadcrumbEntityMixin'

    export default {
        mixins: [breadcrumbEntityMixin],
        name: 'destination-tabs',
        props: {
            id: Number,
        },

        data() {
            return {
                models: {},
                defaultInput: {},
            }
        },

        computed: {
            entityTitle()  {
                return this.models.destination ? ['code', 'name'].reduce((acc, key) => this.models.destination[key] ? acc.concat(this.models.destination[key]) : acc, []).join(' - ') : ''
            }
        },        

        created() {
            this.$store.commit('endProgress')
            this.axios.get('companydestinations/' + this.id).then(response => {
                // get body data
                this.models = response.data.models             
                this.defaultInput = {'company_id': this.models.company.id, 'destination_id': this.id}

            }, response => {
                // error callback
            })
        },
    }
</script>